import {
    Toast,
    ToastClose,
    ToastDescription,
    ToastProvider,
    ToastTitle,
    ToastViewport,
} from "@/components/ui/toast"
import { useToast } from "@/hooks/use-toast"
import { X } from "lucide-react"

export function Toaster() {
    const { toasts, dismissAll } = useToast()

    const handleClearAll = () => {
        dismissAll()
    }

    return (
        <ToastProvider>
            {/* Clear All button - shown when there are 2+ toasts */}
            {toasts.length >= 2 && (
                <div className="fixed bottom-4 right-4 z-[101] md:right-4">
                    <button
                        type="button"
                        onClick={handleClearAll}
                        className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-md bg-secondary hover:bg-secondary/80 text-secondary-foreground transition-colors shadow-lg"
                    >
                        <X className="h-3 w-3" />
                        Clear All ({toasts.length})
                    </button>
                </div>
            )}
            {toasts.map(function ({ id, title, description, action, onClick, ...props }) {
                return (
                    <Toast
                        key={id}
                        {...props}
                        className={onClick ? "cursor-pointer" : undefined}
                        onClick={onClick ? (e) => {
                            // Don't trigger onClick if clicking on interactive elements
                            const target = e.target as HTMLElement
                            if (target.closest('button') || target.closest('a')) {
                                return
                            }
                            onClick()
                        } : undefined}
                    >
                        <div className="grid gap-1 flex-1 min-w-0">
                            {title && <ToastTitle>{title}</ToastTitle>}
                            {description && (
                                <ToastDescription>{description}</ToastDescription>
                            )}
                        </div>
                        {action}
                        <ToastClose />
                    </Toast>
                )
            })}
            <ToastViewport />
        </ToastProvider>
    )
}
